import {ACCEPT_FAILED, API_CALL, RECEIVE_ACCEPT, REQUEST_ACCEPT} from "./types";
import {hasError} from "./actionHelpers";
import {toast} from "react-toastify";

export const requestAcceptance = (id) => ({
  type: API_CALL,
  onRequest: REQUEST_ACCEPT,
  onResponse: RECEIVE_ACCEPT,
  onError: ACCEPT_FAILED,
  responseKey: 'accept',
  payload: {
    method: 'POST',
    url: `/ios/${id}/requestBuyerAcceptance`
  }
});

export const requestAcceptanceWithNotifications = (id) => (dispatch, getState) => {
  let message = `Sending to buyer for ${id}`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(requestAcceptance(id)).then(() => {
    const err = hasError(getState(), 'acceptRequest', dispatch);
    if (err) {
      message = 'Send to buyer failed';
      toast.error(message, { theme: 'colored', toastId: message });
      return;
    }
    message = `Sent to buyer`;
    toast.success(message, { theme: 'colored', toastId: message });
  });
};
